export function setCookie (cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();

    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

export function getCookie (cname) {
    let name = cname + "=",
        ca = document.cookie.split(';');
    for (let c of ca) {
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

export function removeCookie (cname) {
    setCookie(cname, "" ,-1);
}

export function getWindowInnerWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}

export function getWindowInnerHeight () {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

export function elementExisits (el) {
    return el !== undefined && el !== 'unefined' && el !== null;
}

export function isTouchDevice () {
    return ('ontouchstart' in document.documentElement);
}

export function elementInViewport (el) {

    if(el) {

        let top = el.offsetTop;
        let left = el.offsetLeft;
        let width = el.offsetWidth;
        let height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }
}

export function stopPageScroll (classname) {
    let wrapper = document.getElementById('overflow-wrapper');

    if(!wrapper.classList.contains(classname)) {
        wrapper.style.top = '-' + window.scrollY + 'px';
        wrapper.classList.add(classname);
    }
}

export function enablePageScroll (classname) {
    let wrapper = document.getElementById('overflow-wrapper'),
      top = parseInt(wrapper.style.top, 10) * -1;

    if(wrapper.classList.contains(classname)) {
        wrapper.classList.remove(classname);
        wrapper.style.top = '';

        window.scrollTo(0, parseInt(top, 10));
    }
}